<template>
    <div id="app" class="framework7-root ios" :class="'page-' + $router.currentRoute.name.toLowerCase()">
       
        <div class="view view-main safe-areas" data-url="/">

            <keep-alive max="15">
                <router-view :key="$route.fullPath"/>
            </keep-alive>        
        </div>    

        <div class="modal-teleconsulta" v-if="$root.modalTeleconsulta" v-bind:class="{'closed': $root.modalTeleconsulta == 'closed'}" >
            <div class="row" v-show="$root.modalTeleconsulta == 'closed'">
                <div class="col-100">
                    <a class="float-right button small color-primary" v-on:click="$root.setModalTeleconsulta('opened')" v-if="$root.modalTeleconsulta == 'closed'">
                        <i class="las la-angle-up"></i> Mostrar teleconsulta
                    </a>                        
                </div>
            </div>
            <div class="row" v-show="$root.modalTeleconsulta == 'opened' && $root.teleconsulta">
                <div class="col-100">
                    <h4 class="mb-15 mt-0">
                        <i class="las la-info-circle"></i>
                        Informações da teleconsulta:
                        <a class="float-right button small gray" v-on:click="$root.setModalTeleconsulta('closed')" v-if="$root.modalTeleconsulta == 'opened'">
                            <i class="las la-angle-down"></i> Esconder
                        </a>                        
                    </h4>
                </div>
                <div class="col-100" v-if="$root.teleconsulta.contratante">
                    <div class="pl-20">
                        <h4 class="mb-0 mt-0">
                            <router-link class="link" :to="{'name': 'ProntuarioPacientes', 'query': {'c': $root.teleconsulta.contratante.cod}}"><u>{{$root.teleconsulta.contratante.nome}}</u></router-link>
                        </h4>
                        <div class="mb-20" style="line-height: 150%; padding-left: 10px;">
                            - Id: <b>{{$root.teleconsulta.id}}</b>
                            <br>- Agendamento: <b>{{$root.teleconsulta.dataExtenso}}</b>
                            <br>- Status:   
                            <small v-if="$root.teleconsulta.status == 2">
                                <span style="height: auto !important;" class="badge color-yellow">
                                    Aguardando paciente
                                </span>
                            </small> 
                            <small v-if="$root.teleconsulta.status == 3">
                                <span style="height: auto !important;" class="badge color-blue">
                                    Atendimento em andamento
                                </span>
                            </small> 
                            <small v-if="$root.teleconsulta.status == 4">
                                <span style="height: auto !important;" class="badge color-orange">
                                    Atendimento realizado
                                </span>
                            </small> 
                            <small v-if="$root.teleconsulta.status == 5">
                                <span style="height: auto !important;" class="badge color-green">
                                    Atendimento realizado
                                </span>
                            </small> 
                            <small v-if="$root.teleconsulta.status == -1">
                                <span style="height: auto !important;" class="badge color-red">
                                    Cancelado
                                </span>
                            </small>     

                            <div ></div>

                            <button type="button" class="button button-medium button-outline mt-15" style="width: auto !important; margin-left: 13px; display: inline-block;" v-on:click="$root.go('ProntuarioPacientes', JSON.stringify({'c': $root.teleconsulta.contratante.cod}))">
                                Visualizar prontuário
                            </button>
                            <button class="button button-medium button-outline color-green mt-15" type="button" style="width: auto !important; margin-left: 13px; display: inline-block;" v-on:click="$root.finalizarTeleconsulta()" v-if="$root.teleconsulta.status == 3 && ($root.user.tipo == 'prestador')">
                                <i class="las la-check-circle"></i>
                                Concluir consulta
                            </button>                                            
                        </div>
                    </div>
                </div>                                           
            </div>
            <div class="chamada-video" style="" v-show="$root.modalTeleconsulta == 'opened'">
                <div id="remote-media" v-show="$root.chamada"></div>
                <div id="local-media" v-show="$root.chamada"></div>

                <button v-show="$root.chamada" class="mute-audio" v-on:click="$root.muteAudio()">
                    <i class="las la-microphone-slash" v-show="!$root.chamadaMute.audio"></i>
                    <i class="las la-microphone" v-show="$root.chamadaMute.audio"></i>
                </button>
                <button v-show="$root.chamada" class="mute-video" v-on:click="$root.muteVideo()">
                    <i class="las la-video-slash" v-show="!$root.chamadaMute.video"></i>
                    <i class="las la-video" v-show="$root.chamadaMute.video"></i>
                </button>                                       
            </div>              
        </div>

        <div id="modal-termos-de-uso" class="modal">
            <div class="row">
                <div class="col-100">
                    <!-- Row -->
                    <div class="row">

                        <div class="col-100">                                          
                            <h3><b>Termos de uso</b></h3>
                        </div>

                        <div class="col-100 v-html" id="termos-de-uso-html">

                        </div>  
              
                    </div>
                </div>
            </div>
        </div>

        <div id="modal-politicas-de-privacidade" class="modal">
            <div class="row">
                <div class="col-100">
                    <!-- Row -->
                    <div class="row">

                        <div class="col-100">                                          
                            <h3 class=""><b>Políticas de privacidade</b></h3>
                        </div>

                        <div class="col-100 v-html" id="politicas-de-privacidade-html">
                        </div>                    
                    </div>
                </div>
            </div>
        </div> 


        <div class="popup-avaliacao" v-if="$root.avaliacao">
            <div class="container">
                <div class="row ">    
                    <div class="col-100 center">
                        <h4 class="" style="font-size: 24px; line-height: 130%; margin-bottom: 10px">
                            <i class="las la-smile"></i>
                            Atendimento realizado com sucesso!
                        </h4>
                        <center>
                            <img src="static/images/avaliacao.png" style="width: 200px">
                        </center>                                                                                                            
                    </div>                                                                                                            
                    <div class="col-100 center  mb-10 mt-0">
                        <h5 class="mb-15">
                            <i class="las la-question"></i>
                            Como foi a sua experiência?
                        </h5>
                        <small class="block">Deixe uma nota para <b>{{$root.avaliacao.prestador.nome}}</b></small>
                    </div>        
                    <div class="col-100 mb-10 center">
                        <table class="grid avaliacao" style="">
                            <tr>
                                <td style="" v-on:click="$root.setAvaliacaoNota(1);">
                                    <i v-show="$root.formAvaliacao.nota >= 1" class="las la-star"></i>
                                    <i v-show="$root.formAvaliacao.nota < 1" class="lar la-star"></i>
                                </td>
                                <td style="" v-on:click="$root.setAvaliacaoNota(2);">
                                    <i v-show="$root.formAvaliacao.nota >= 2" class="las la-star"></i>
                                    <i v-show="$root.formAvaliacao.nota < 2" class="lar la-star"></i>                                
                                </td>
                                <td style="" v-on:click="$root.setAvaliacaoNota(3);">
                                    <i v-show="$root.formAvaliacao.nota >= 3" class="las la-star"></i>
                                    <i v-show="$root.formAvaliacao.nota < 3" class="lar la-star"></i>                                
                                </td>
                                <td style="" v-on:click="$root.setAvaliacaoNota(4);">
                                    <i v-show="$root.formAvaliacao.nota >= 4" class="las la-star"></i>
                                    <i v-show="$root.formAvaliacao.nota < 4" class="lar la-star"></i>                                
                                </td>
                                <td style="" v-on:click="$root.setAvaliacaoNota(5);">
                                    <i v-show="$root.formAvaliacao.nota >= 5" class="las la-star"></i>
                                    <i v-show="$root.formAvaliacao.nota < 5" class="lar la-star"></i>                                
                                </td>                                                                                                                                                         
                            </tr>
                        </table>    
                    </div> 
                    <div class="col-100 ">       
                        <textarea class="form-control" v-model="$root.formAvaliacao.texto" style="padding: 20px; height: 90px; min-height: 1px; width: 100%; border: 1px solid #eee; border-radius: 20px" placeholder="Deixe um comentário aqui.."></textarea>
                    </div> 
                    <div class="col-100 mt-20 mb-50 " style="margin-bottom: 50px">
                        <button type="button" class="button-large button button-fill" v-on:click="$root.submitAvaliacao()">
                            <i class="las la-check-circle"></i>
                            <b>Enviar avaliação</b>
                        </button>
                    </div>                             
                </div>       
                
            </div>
        </div>

    </div>
</template>

<script>
// import Top from './components/Top'

export default {
    name: 'App',
    components: {
        // 'Top': Top,
    },
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});
            } else {
                return "0,00";
            }
            // return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2})                
        },        
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            if (time) {
                d = time.split(":");
                time = d[0] + ":" + d[1];
            }
            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + (time ? (" " + time) : "");
        }
    },    
    methods: {
        getHtml: function() {
            var self        = this;
            console.log("getHtml()", self.form);
       
            return axios.get("templates/termos-de-uso-app.html", {params: {}})
            .then(response => {
                
                console.log("getHtml() response", response);    
                $("#termos-de-uso-html").html(response.data);
                
                return axios.get("templates/politicas-de-privacidade-app.html", {params: {}})
            })
            .then(response => {
                
                console.log("getHtml() response", response);    
                $("#politicas-de-privacidade-html").html(response.data);

            })                
            .catch(error => {
                console.log("getHtml() error", error);                    
                reject(error);
            });   
        },    
    },             
    created: function() {
        var self = this;
        window.___app = self;
        self.getHtml();
    }    
}
</script>

<style>

    .popup-avaliacao {
        position: fixed;
        top: 0px;
        height: 100vh;
        overflow-y: scroll;        
        bottom: 0px;
        left: 0px;
        right: 0px;
        /*top: auto;*/
        z-index: 99999;
        background: #fff;
        border-top-right-radius: 0px;
        border-top-left-radius: 0px;
        padding: 5px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
        border-top: 1px solid #ccc;        
    }

    .popup-avaliacao .center {
        text-align: center !important;
    }

    .grid.avaliacao {
        max-width: 95vw !important; 
        width: auto !important; 
        margin: 0 auto !important;
    }
    .grid.avaliacao td {
        width: 20%; 
        font-size: 2em; 
        padding: 5px;
    }
    .grid.avaliacao i {
        color: #0AD744;
    }

    .tingle-modal .v-html {
        font-weight: 400 !important;
    }

    #app {


    }

    ol {
        color: #333;
        padding-left: 12px;
    }    


    #remote-media {
        width: 100%;
        text-align: center;
        height: 100%;
        /* height: 31vh; */
    }

    #remote-media div {
        height: 100% !important;
    }

    #remote-media video {
        width: auto !important;
        height: 100% !important;        
        /* height: 80vh !important;         */
        /* height: auto; */
        max-width: 100%;
        min-height: 30vh !important;
        /*width: auto;*/
        /* margin-top: 6px; */
    }

    #local-media {
        display: flex;
        position: absolute;
        right: 10px;
        bottom: 10px;
        width: 100px;
        height: 100px;
        background: #000;
        /*border: 1px solid #ddd;*/
    }

    #local-media video {
        width: 100%;
    }

    .chamada-video {
        display: flex;
        align-items: center;
        background-color: #ddd; 
        height: 325px;   
        /* height: 100%;    */
        /* position: relative; */
        /* margin-top: 10px; */
        min-height: 30vh;
    }

    .chamada-video .placeholder {
        width: 100%;
        opacity: 0.1;
    }

    .chamada-video p {
        text-align: center;
        color: #fff;
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;    
        position: absolute;
    }


    .mute-audio {
        position: absolute;
        bottom: 15px;
        left: 15px;
        background: rgba(255,255,255,0.5);
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-audio i {
        font-size: 30px;
        color: var(--f7-theme-color);
        position: relative;
        top: 2px;   
    }

    .mute-video {
        position: absolute;
        bottom: 15px;
        left: 75px;
        background: rgba(255,255,255,0.5);
        border: 2px solid #ddd;
        border-radius: 50%;
        height: 50px;
        width: 50px;
    }
    .mute-video i {
        font-size: 30px;
        color: var(--f7-theme-color);
        position: relative;
        top: 2px;   
    }    


    @media only screen and (max-width: 500px) { 
        .modal-teleconsulta:not(.closed) {
            width: auto;
            left: 10px;
            right: 10px;
        }        
    }

    .modal-teleconsulta span.dashboard-status-button {
        font-size: 12px !important;
        line-height: 14px;
        margin-left: 6px;
    }

    .modal-teleconsulta {
        position: fixed;
        bottom: 10px;   
        top: auto;   
        right: 10px;
        /* width: auto; */
        /* height: auto; */
        width: 500px;   
        /* height: 60vh; */
        background: #fff;
        z-index: 99999;   
        padding: 10px;
        border: 1px solid #ddd;
        box-shadow: 0 2px 100px rgb(0 0 0 / 42%) !important;
        border-radius: 20px;
        /* cursor: move; */
        resize: both;

    }

    .modal-teleconsulta.dragged {
        bottom: auto !important;
    }    

    .modal-teleconsulta .button.color-orange {
        padding: 10px;
        font-size: 16px;
    }

    .modal-teleconsulta h4 {
        font-size: 18px !important;
    }

    .modal-teleconsulta.closed {
        width: auto;
        min-width: 215px !important;
        /* height: 58px !important; */
        bottom: 10px !important;
        top: auto !important;
        left: auto !important;
    }


</style>



// WEBPACK FOOTER //
// src/App.vue